import dayjs from 'dayjs';
import { TFunction } from 'i18next';

export const secondsToHHMMSSFormat = (seconds: number | null | undefined) => {
  if (!seconds) return '-';

  const duration = dayjs.duration(seconds, 's');

  if (seconds >= 3600) return duration.format('HH:mm:ss');
  return duration.format('mm:ss');
};

export const secondsToTimeStringFormat = (
  totalSeconds: number | null | undefined,
  t: TFunction,
) => {
  if (!totalSeconds) return '-';

  const duration = dayjs.duration(totalSeconds, 's');

  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return `${hours ? `${t('time.hour', { count: hours, format: 'hour' })} ` : ''} ${minutes ? `${t('time.minute', { count: minutes, format: 'minute' })} ` : ''} ${seconds ? t('time.second', { count: seconds, format: 'second' }) : ''}`;
};
